/**
 * What a glossary term's form and a post's words are compared by -
 * GlossaryTermForms::key() (PHP), which says why: letters and digits,
 * lowercase, without accents, but the "é" of a word's end ("fasciculé"
 * isn't a "fascicule").
 */
export default function glossaryKey(text) {
  return text.normalize('NFC').toLowerCase().split(/[^\p{L}\p{M}\p{N}]+/u).map(word => {
    const letters = Array.from(word);
    const end = letters.length - 3;
    return letters.map((letter, index) => letter === 'é' && index >= end ? letter : ascii(letter)).join('');
  }).join('');
}
function ascii(text) {
  return text.normalize('NFD').replace(/\p{M}/gu, '').replace(/œ/g, 'oe').replace(/æ/g, 'ae').replace(/ß/g, 'ss').replace(/[^a-z0-9]/g, '');
}
flarum.reg.add('champis-others', 'forum/utils/glossaryKey', glossaryKey);